import React from 'react';
import styles from './penalizedFilterLabel.module.css';

type PenalizedFilterLabelProps = {
  children: string;
};

const PenalizedFilterLabel: React.FC<PenalizedFilterLabelProps> = ({
  children,
}) => <div className={styles.label}>{children}</div>;

export default PenalizedFilterLabel;
